import { Component } from '@angular/core';

@Component({
  selector: 'dc-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['footer.scss']
})
export class FooterComponent {}
